export default __webpack_public_path__ + "static/media/hair-2-4.8471870b.svg";